const MuiTypography = {
    variantMapping: {
        inherit: 'p',
    },
};

export default MuiTypography;
